<script setup>
import { ref } from 'vue';
import { onClickOutside } from '@vueuse/core';
import { useI18n } from 'vue-i18n';

import Button from 'dashboard/components-next/button/Button.vue';
import EmojiIconPicker from 'dashboard/components-next/emoji-icon-picker/EmojiIconPicker.vue';
import { ORIENTATION } from './constants';

const props = defineProps({
  orientation: { type: String, required: true },
});

const emit = defineEmits(['select']);

const { t } = useI18n();
const container = ref(null);
const isOpen = ref(false);

onClickOutside(container, () => {
  isOpen.value = false;
});

// EmojiIconPicker emits the whole selection ({ value }) because it can also return icons; only the emoji
// character matters here.
const selectEmoji = selection => {
  isOpen.value = false;
  emit('select', selection?.value ?? selection);
};
</script>

<template>
  <div ref="container" class="relative flex self-center">
    <Button
      v-tooltip="t('CONVERSATION.CONTEXT_MENU.REACT')"
      ghost
      slate
      xs
      icon="i-lucide-smile-plus"
      class="transition-opacity opacity-0 group-hover/message:opacity-100 focus-visible:opacity-100"
      :class="{ 'opacity-100': isOpen }"
      @click="isOpen = !isOpen"
    />
    <!-- Opens upwards: a message sits low in a scrolled thread far more often than at the top. -->
    <div
      v-if="isOpen"
      class="absolute z-40 bottom-8"
      :class="
        orientation === ORIENTATION.RIGHT
          ? 'ltr:right-0 rtl:left-0'
          : 'ltr:left-0 rtl:right-0'
      "
    >
      <EmojiIconPicker mode="emoji" @select="selectEmoji" />
    </div>
  </div>
</template>
